import { computed } from '@vue/composition-api';
import { useAuthUser } from './use-auth-user';
import { useViewer } from './use-viewer';
export const useRoleChecker = (ctx) => {
    const { hasRole: hasAuthRole } = useAuthUser();
    const { isPreviewMode, hasRole: hasViewerRole } = useViewer(ctx);
    const checkRole = (role, checkInPreviewMode = true) => {
        return computed(() => {
            if (isPreviewMode.value && checkInPreviewMode) {
                return hasViewerRole(role);
            }
            return hasAuthRole(role);
        });
    };
    const checkAnyRole = (roles, checkInPreviewMode = true) => {
        return computed(() => {
            if (isPreviewMode.value && checkInPreviewMode) {
                return roles.some((role) => hasViewerRole(role));
            }
            return roles.some((role) => hasAuthRole(role));
        });
    };
    return {
        checkRole,
        checkAnyRole,
    };
};
